import { render, staticRenderFns } from "./WSurveysList.vue?vue&type=template&id=2d1b51a6&"
import script from "./WSurveysList.vue?vue&type=script&lang=ts&"
export * from "./WSurveysList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports